module.exports = __webpack_public_path__ + "img/patentes.04c63178.png";